
import { mapState, mapMutations } from 'vuex';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'TestimonialBlockSingle',

  components: {
    WpImage,
  },

  props: {
    postId: {
      type: Number,
      required: true,
    },
  },

  async fetch() {
    const { data } = await this.$wp.testimonials({ id: this.postId });
    if (data) {
      this.addTestimonial(data);
    } else {
      return this.$nuxt.error({
        statusCode: 404,
      });
    }
  },

  computed: {
    ...mapState(['testimonials']),

    testimonial() {
      return this.testimonials.find((t) => t.id === this.postId);
    },

    avatar() {
      return this.testimonial ? this.testimonial.fields.avatar : null;
    },

    quote() {
      return this.testimonial ? this.testimonial.fields.quote : null;
    },

    name() {
      return this.testimonial ? this.testimonial.fields.name : null;
    },

    weight() {
      return this.testimonial ? `-${this.testimonial.fields.weight}kg` : null;
    },

    title() {
      return this.testimonial ? this.testimonial.title.rendered : null;
    },
  },

  methods: {
    ...mapMutations(['addTestimonial']),
  },
};
